import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar";
import Sidebar from "../../components/Sidebar";
import axios from "axios";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import ConfirmModal from "../../components/ConfirmModal"; // Import Reusable Modal
import "../../assets/ListingModal.css";

function ProductList() {
  const [productlist, setproductlist] = useState([]);
  const [catagorylist, setcatagorylist] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const token = sessionStorage.getItem("token");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const filteredData = productlist.filter((item) =>
    Object.values(item).some(
      (val) =>
        val &&
        typeof val === "string" &&
        val.toLowerCase().includes(search.toLowerCase())
    )
  );

  const offset = currentPage * itemsPerPage;
  const paginatedData = filteredData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(filteredData.length / itemsPerPage);

  const fetchProductList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/productlist?isAdmin=true`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setproductlist(response.data?.products || []);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
        (error.response?.data?.message || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteProduct = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }
    try {
      const response = await fetch(
        `${process.env.REACT_APP_APIURL}api/deleteproduct/${deleteId}`,
        {
          method: "delete",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Product deleted successfully!");
        fetchProductList();
      } else {
        const data = await response.json();
        toast.error(data.message || "Failed to delete Product");
      }
    } catch (error) {
      toast.error("Something went wrong! Please try again later.");
    }
    setShowDeleteModal(false);
  };

  const fetchCategoryList = async () => {
    if (!token) {
      toast.error("No token provided!");
      return;
    }

    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/catagorylist?isAdmin=true`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setcatagorylist(response.data?.catagories || []);
    } catch (error) {
      toast.error(
        "Error fetching data: " +
        (error.response?.data?.message || error.message)
      );
    } finally {
      setIsLoading(false);
    }
  };

  const fetchShiftList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_APIURL}api/shift/all`);
      setShiftList(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching shifts:", error);
    }
  };

  const getCategoryName = (categoryId) => {
    if (!categoryId || !Array.isArray(catagorylist)) return "N/A";
    const category = catagorylist.find((cat) => cat?._id === categoryId);
    return category?.catagoryname || "N/A";
  };

  const formatTime = (timeString) => {
    if (!timeString) return "N/A";
    try {
      const [hours, minutes] = timeString.split(":");
      const h = parseInt(hours);
      const ampm = h >= 12 ? "PM" : "AM";
      const formattedHours = h % 12 || 12;
      return `${formattedHours}:${minutes} ${ampm}`;
    } catch (e) {
      return timeString;
    }
  };

  const getShiftNames = (shiftIds) => {
    if (!shiftIds || !Array.isArray(shiftIds) || shiftIds.length === 0) return "No shifts assigned";
    return shiftIds
      .map((id) => {
        const shift = shiftList.find((s) => s._id === id);
        return shift ? `${shift.name} (${formatTime(shift.startTime)} - ${formatTime(shift.endTime)})` : "Unknown Shift";
      })
      .join(", ");
  };

  const handleViewProduct = async (productId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIURL}api/productdetails/${productId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSelectedProduct(response.data.product);
      setShowProductModal(true);
    } catch (error) {
      toast.error("Error fetching product details: " + error.message);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await Promise.all([fetchProductList(), fetchCategoryList(), fetchShiftList()]);
    };
    fetchData();
  }, []);

  return (
    <>
      <Topbar />
      <Sidebar />
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Product List</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to={"/"}>Home</Link>
              </li>
              <li className="breadcrumb-item active">Product List</li>
            </ol>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  {isLoading ? (
                    <div className="text-center p-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <>
                      {/* Search and Entries Per Page */}
                      <div className="datatable-top d-flex justify-content-between align-items-center pt-4">
                        <div className="datatable-dropdown w-100">
                          <label className="me-2">
                            Show{" "}
                            <select
                              className="datatable-selector"
                              value={itemsPerPage}
                              onChange={(e) =>
                                setItemsPerPage(Number(e.target.value))
                              }
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="15">15</option>
                              <option value="-1">All</option>
                            </select>{" "}
                            entries
                          </label>
                        </div>
                        <div className="datatable-search">
                          <input
                            className="form-control"
                            placeholder="Search..."
                            type="search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                        </div>
                      </div>

                      {/* Table */}
                      <div className="datatable-container overflow-auto">
                        <table
                          className="table datatable table-bordered table-striped align-middle"
                          style={{
                            width: "100%",
                          }}
                        >
                          <thead>
                            <tr>
                              <th>SL</th>
                              <th>Product Name</th>
                              <th>Product image</th>
                              <th>Catagory</th>
                              <th>SKU</th>
                              <th>Variation</th>
                              <th style={{ minWidth: "250px" }}>Display Shift</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedData.length > 0 ? (
                              paginatedData.map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td style={{ minWidth: "200px", whiteSpace: "normal" }}>
                                    {item.product_name}
                                  </td>
                                  <td>
                                    {item?.productImage ? (
                                      <div
                                        className="product-image-thumbnail"
                                        onClick={() => {
                                          setSelectedImage(item.productImage);
                                          setShowModal(true);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <div
                                          style={{
                                            width: "50px",
                                            height: "50px",
                                            backgroundImage: `url(${item.productImage})`,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            borderRadius: "4px",
                                            border: "1px solid #ddd",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <div className="no-image-placeholder">
                                        <i
                                          className="bi bi-image text-muted"
                                          style={{ fontSize: "24px" }}
                                        ></i>
                                      </div>
                                    )}
                                  </td>
                                  <td>{getCategoryName(item.category)}</td>
                                  <td>{item.sku}</td>
                                  <td>{item.variation}</td>
                                  <td style={{ whiteSpace: "normal" }}>
                                    {getShiftNames(item.displayShifts)}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      <Link
                                        onClick={() =>
                                          handleViewProduct(item._id)
                                        }
                                      >
                                        <i className="bi bi-eye text-danger"></i>
                                      </Link>
                                      <Link to={`/updateproduct/${item._id}`}>
                                        <i className="bi bi-pencil-square text-primary"></i>
                                      </Link>
                                      <Link
                                        onClick={() => {
                                          setDeleteId(item._id);
                                          setShowDeleteModal(true);
                                        }}
                                      >
                                        <i className="bi bi-trash text-danger"></i>
                                      </Link>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="10" className="text-center">
                                  No matching records found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* Image Preview Modal */}
                      {showModal && (
                        <div
                          className="modal show d-block"
                          tabIndex="-1"
                          style={{
                            backgroundColor: "rgba(0,0,0,0.5)",
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1050,
                          }}
                        >
                          <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">
                                  Product Image Preview
                                </h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setShowModal(false)}
                                ></button>
                              </div>
                              <div className="modal-body text-center">
                                <img
                                  src={selectedImage}
                                  alt="Product preview"
                                  style={{
                                    maxWidth: "100%",
                                    maxHeight: "500px",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Product Details Modal */}
                      {showProductModal && selectedProduct && (
                        <div
                          className="modal show d-block"
                          tabIndex="-1"
                          style={{
                            backgroundColor: "rgba(0,0,0,0.5)",
                            position: "fixed",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            zIndex: 1050,
                          }}
                        >
                          <div className="modal-dialog modal-dialog-centered modal-lg">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Product Details</h5>
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setShowProductModal(false)}
                                ></button>
                              </div>
                              <div className="modal-body">
                                <div className="row">
                                  <div className="col-md-5">
                                    <div className="product-main-image mb-3">
                                      <img
                                        src={selectedProduct.productImage}
                                        alt={selectedProduct.product_name}
                                        className="img-fluid rounded"
                                        style={{
                                          width: "100%",
                                          height: "auto",
                                        }}
                                      />
                                    </div>
                                    {selectedProduct.galleryImages &&
                                      selectedProduct.galleryImages.length >
                                      0 && (
                                        <div className="gallery-images d-flex gap-2 flex-wrap">
                                          {selectedProduct.galleryImages.map(
                                            (image, index) => (
                                              <img
                                                key={index}
                                                src={image}
                                                alt={`Gallery ${index + 1}`}
                                                className="img-thumbnail"
                                                style={{
                                                  width: "80px",
                                                  height: "80px",
                                                  objectFit: "cover",
                                                }}
                                                crossOrigin="anonymous"
                                              />
                                            )
                                          )}
                                        </div>
                                      )}
                                  </div>
                                  <div className="col-md-7">
                                    <h4 className="mb-3">
                                      {selectedProduct.product_name}
                                    </h4>
                                    <div className="product-details">
                                      <p>
                                        <strong>Category:</strong>{" "}
                                        {getCategoryName(
                                          selectedProduct.category
                                        )}
                                      </p>
                                      <p>
                                        <strong>SKU:</strong>{" "}
                                        {selectedProduct.sku}
                                      </p>
                                      <p>
                                        <strong>Variation Type:</strong>{" "}
                                        {selectedProduct.variation}
                                      </p>
                                      <p>
                                        <strong>Display Shifts:</strong>{" "}
                                        {getShiftNames(selectedProduct.displayShifts)}
                                      </p>

                                      {selectedProduct.variation ===
                                        "Simple" ? (
                                        <>
                                          <p>
                                            <strong>Regular Price:</strong> ₹
                                            {selectedProduct.reguler_price}
                                          </p>
                                          <p>
                                            <strong>Discount Price:</strong> ₹
                                            {selectedProduct.discount_price}
                                          </p>
                                          <p>
                                            <strong>Stock:</strong>{" "}
                                            {selectedProduct.stock}
                                          </p>
                                        </>
                                      ) : (
                                        <div className="variable-products mt-3">
                                          <h6 className="mb-3">
                                            Product Variations:
                                          </h6>
                                          <div className="table-responsive">
                                            <table className="table table-bordered">
                                              <thead>
                                                <tr>
                                                  <th>Size</th>
                                                  <th>Color</th>
                                                  <th>Regular Price</th>
                                                  <th>Discount Price</th>
                                                  <th>Stock</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {selectedProduct.attributes.map(
                                                  (attr, index) => (
                                                    <tr key={index}>
                                                      <td>{attr.size}</td>
                                                      <td>{attr.color}</td>
                                                      <td>
                                                        ₹
                                                        {
                                                          attr.other_attributes
                                                            .price
                                                        }
                                                      </td>
                                                      <td>
                                                        ₹
                                                        {
                                                          attr.other_attributes
                                                            .discount_price
                                                        }
                                                      </td>
                                                      <td>
                                                        {
                                                          attr.other_attributes
                                                            .stock
                                                        }
                                                      </td>
                                                    </tr>
                                                  )
                                                )}
                                              </tbody>
                                            </table>
                                          </div>
                                        </div>
                                      )}

                                      {selectedProduct.attributes &&
                                        selectedProduct.attributes.length > 0 &&
                                        selectedProduct.variation ===
                                        "Simple" && (
                                          <div className="attributes mb-3">
                                            <h6>Attributes:</h6>
                                            <ul className="list-unstyled">
                                              {selectedProduct.attributes.map(
                                                (attr, index) => (
                                                  <li key={index}>{attr}</li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        )}
                                    </div>
                                  </div>
                                </div>
                                <div className="row mt-4">
                                  <div className="col-12">
                                    <h6>Description:</h6>
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: selectedProduct.description,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="modal-footer">
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={() => setShowProductModal(false)}
                                >
                                  Close
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="datatable-bottom d-flex justify-content-between align-items-center">
                        <span className="w-100">
                          Showing {offset + 1} to{" "}
                          {offset + paginatedData.length} of{" "}
                          {filteredData.length} entries
                        </span>

                        <ReactPaginate
                          previousLabel={"‹"}
                          nextLabel={"›"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={1}
                          pageRangeDisplayed={2}
                          onPageChange={(e) => setCurrentPage(e.selected)}
                          containerClassName={"pagination"}
                          activeClassName={"active"}
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          previousClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextClassName={"page-item"}
                          nextLinkClassName={"page-link"}
                          breakClassName={"page-item"}
                          breakLinkClassName={"page-link"}
                        />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      {/* Reusable Delete Confirmation Modal */}
      <ConfirmModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteProduct}
        title="Confirm Deletion"
        message="Are you sure you want to delete this product?"
      />
    </>
  );
}

export default ProductList;
